/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import TenantsDetailsPanel from './layout';

export default TenantsDetailsPanel;
